import { getHierarchy } from '../api/catalog';

export const SYNC_HIERARCHY_SUCCESS = 'SYNC_HIERARCHY_SUCCESS';
export const SYNC_HIERARCHY_ERROR = 'SYNC_HIERARCHY_ERROR';

// Background-refetch the cached hierarchy once it's older than this
const STALE_MS = 5 * 60 * 1000;

// Module-level so single-flight survives redux-persist; a persisted in-flight flag could wedge forever
let inFlight = null;

export const syncCatalogHierarchy = () => async dispatch => {
  try {
    const resp = await getHierarchy();
    if (resp.success) {
      return dispatch({
        type: SYNC_HIERARCHY_SUCCESS,
        industries: resp.industries,
        brands: resp.brands,
        lastFetchedAt: Date.now()
      });
    }
    return dispatch({
      type: SYNC_HIERARCHY_ERROR,
      error: resp.error
    });
  } catch (error) {
    console.error('Failed to sync catalog hierarchy', error);
    return dispatch({
      type: SYNC_HIERARCHY_ERROR,
      error
    });
  }
};

// Lazy entry point: fetch only when missing or stale, and never twice concurrently
export const ensureCatalogHierarchy = () => (dispatch, getState) => {
  if (inFlight) return inFlight;
  const { industries, lastFetchedAt } = getState().catalog;
  const isFresh = lastFetchedAt && Date.now() - lastFetchedAt < STALE_MS;
  if (industries?.length && isFresh) return Promise.resolve();
  inFlight = dispatch(syncCatalogHierarchy()).finally(() => {
    inFlight = null;
  });
  return inFlight;
};
